/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Model_Downgraded_ErrorInputs */

const en_model_downgraded_error = /** @type {(inputs: Model_Downgraded_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} failed — this used ${i?.to} instead. Your credits were not charged.`)
};

const id_model_downgraded_error = /** @type {(inputs: Model_Downgraded_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} gagal — hasil ini memakai ${i?.to}. Kredit kamu tidak dipotong.`)
};

/**
* | output |
* | --- |
* | "{from} failed — this used {to} instead. Your credits were not charged." |
*
* @param {Model_Downgraded_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_downgraded_error = /** @type {((inputs: Model_Downgraded_ErrorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Downgraded_ErrorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_downgraded_error(inputs)
	return en_model_downgraded_error(inputs)
});